 import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import swal from 'sweetalert2';
import * as ProAct from '../../Actions/ProActions';
// import { desabonnerEcourrier, obtenirProprietaire } from '../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card, { LigneCard } from '../Card';
import Tableau from '../Tableau';
import NoticeCourrierElectroniqueNG from '../../PDF/NoticeCourrierElectroniqueNG.pdf';
import CourrierElectroniqueSimple from '../../PDF/CourrierElectroniqueSimple.pdf'
// function SeDesabonner(Consentement, actions, history) {
//     swal({
//         title: 'Confirmation',
//         text: 'Êtes-vous sûr(e) de vouloir vous désabonner du service courrier électronique ?',
//         type: 'warning',
//         showCancelButton: true,
//         focusCancel: true,
//         confirmButtonColor: '#28a745',
//         confirmButtonText: 'Confirmer',
//         cancelButtonText: 'Annuler',
//         footer: Consentement === 2 ? 'Attention, cela supprimera aussi votre consentement aux lettres recommandées électroniques.' : ''
//     }).then((result) => {
//         if (result.value) {
//             desabonnerEcourrier(Consentement).then((response) => {
//                 if (response) {
//                     swal('Succès', 'Votre désinscription au service courrier électronique est effective.', 'success');
//                     obtenirProprietaire().then((pro) => {
//                         actions.proAjout(pro);
//                     });
//                     history.push('/MesInformations');
//                 } else {
//                     swal(
//                         'Erreur',
//                         "Une erreur s'est produite lors de la désinscription au service courrier électronique.",
//                         'error',
//                     );
//                 }
//             });
//         }
//     });
// }

const AfficherEcourrier = ({
    Nom, Prenom, Email, Tel, Param, CourrierSimple,
}) => (
    <React.Fragment>
        <div className="card-text mb-3">
            <LigneCard titre="Nom" valeur={Nom} />
            <LigneCard titre="Prénom" valeur={Prenom} />
            <LigneCard titre="Email" valeur={Email} />
            <LigneCard titre="Téléphone" valeur={Tel} />
            {CourrierSimple ? <ParamEnvoiSimple Param={Param} /> : <ParamEnvoi Param={Param} />} 
            {/* <LigneCard titre="Notifications simples" valeur={Param.NotifSimple ? "Electronique" : "Postal"} iconePre={Param.NotifSimple ? "text-success fas fa-check" : "text-danger fas fa-close"} longTitre/>
            <LigneCard titre="Notifications recommandées" valeur={Param.NotifRecommandee ? "Electronique" : "Postal"} iconePre={Param.NotifRecommandee ? "text-success fas fa-check" : "text-danger fas fa-close"} longTitre/>
            <LigneCard titre="Mises en demeure" valeur={Param.MiseDemeure ? "Electronique" : "Postal"} iconePre={Param.MiseDemeure ? "text-success fas fa-check" : "text-danger fas fa-close"} longTitre derniereLigne/> */}
        </div>
        {/* <button onClick={() => SeDesabonner(Consentement, actions, history)} className="btn btn-outline-danger">
            Se désabonner
        </button> */}
        <Link to={{ pathname: '/MesInformations/Ecourrier', state: { Reinscirption: true } }} className="btn btn-outline-orange">
            Modifier les informations
        </Link>
    </React.Fragment>
);

const ParamEnvoi = ({ Param }) => {
    const enTete = (
        <tr>
            <td className="col-8" />
            <td className="col-2 text-secondary">Electronique</td>
            <td className="col-2 text-secondary">Postal</td>
        </tr>
    );

    const corps = (
        <React.Fragment>
            <tr>
                <td className="col-8 text-secondary">Notifications simples</td>
                <td className="col-2 text-center"><i className={Param.NotifSimple ? 'text-success fas fa-check' : ''} /></td>
                <td className="col-2 text-center"><i className={!Param.NotifSimple ? 'text-success fas fa-check' : ''} /></td>
            </tr>
            <tr>
                <td className="col-8 text-secondary">Notifications recommandées</td>
                <td className="col-2 text-center"><i className={Param.NotifRecommandee ? 'text-success fas fa-check' : ''} /></td>
                <td className="col-2 text-center"><i className={!Param.NotifRecommandee ? 'text-success fas fa-check' : ''} /></td>
            </tr>
            <tr>
                <td className="col-8 text-secondary">Mises en demeure</td>
                <td className="col-2 text-center"><i className={Param.MiseDemeure ? 'text-success fas fa-check' : ''} /></td>
                <td className="col-2 text-center"><i className={!Param.MiseDemeure ? 'text-success fas fa-check' : ''} /></td>
            </tr>
        </React.Fragment>
    );
    return <Tableau Entete={enTete} Lignes={corps} PetitesLignes PasDeZebrures className="table-borderless mb-0" />;
};

const ParamEnvoiSimple = ({ Param }) => {
    const enTete = (
        <tr>
            <td className="col-8" />
            <td className="col-2 text-secondary">Electronique</td>
            <td className="col-2 text-secondary">Postal</td>
        </tr>
    );
    const corps = (
        <React.Fragment>
            <tr>
                <td className="col-8 text-secondary">Notifications simples</td>
                <td className="col-2 text-center"><i className={Param.NotifSimple ? 'text-success fas fa-check' : ''} /></td>
                <td className="col-2 text-center"><i className={!Param.NotifSimple ? 'text-success fas fa-check' : ''} /></td>
            </tr>
        </React.Fragment>
    );

    return <Tableau Entete={enTete} Lignes={corps} PetitesLignes PasDeZebrures className="table-borderless mb-0" />;
};


const DemandeEncours = ({ Email }) => (
    <React.Fragment>
        <p className="card-text">
            <i>
                Une demande est en cours à l'adresse : <b>{Email}</b>.
            </i>
        </p>
        <Link to={{ pathname: '/MesInformations/Ecourrier', state: { Reinscirption: true } }} className="btn btn-outline-secondary">
            Se réabonner au service
        </Link>
    </React.Fragment>
);

const PasDeEcourrier = ({ CourrierSimple }) => (
    <React.Fragment>
        <p className="card-text mb-0">
            Ce service <b>pratique</b> et <b>économique</b> vous permet de <b>remplacer</b> vos courriers postaux par
            des courriers électroniques.
        </p>
        {CourrierSimple ?
            <Link
                to={{ pathname: '/MesInformations/Document', state: { URI: CourrierElectroniqueSimple } }}
                className="btn btn-info mt-3 mr-3"
            >
                Voir la notice
            </Link>

            :
            <Link
                to={{ pathname: '/MesInformations/Document', state: { URI: NoticeCourrierElectroniqueNG } }}
                className="btn btn-info mt-3 mr-3"
            >
            Voir la notice
            </Link>
        }
        <Link to="/MesInformations/Ecourrier" className="btn btn-primary mt-3">
            S&apos;abonner au service
        </Link>
    </React.Fragment>
);

const CardEcourrier = ({
    Accueil, Ecourrier, LREOk, actions, history, CourrierSimple,
}) => {
    let className = '';
    let composant = null;

    if (!Ecourrier.OuvertAgence || (!LREOk && !CourrierSimple)) return null;

    /* Si une demande est en cours ou si le service est actif, on n'affiche pas cette Card sur l'accueil */
    if (Accueil && (Ecourrier.Email || Ecourrier.Tel)) return null;

    if (!Ecourrier.Email || !Ecourrier.Tel) {
        className = 'alert-primary';
        composant = <PasDeEcourrier CourrierSimple={CourrierSimple} />;
    } else if (!Ecourrier.Actif) {
        composant = <DemandeEncours {...Ecourrier} />;
    } else {
        composant = <AfficherEcourrier {...Ecourrier} CourrierSimple={CourrierSimple} actions={actions} history={history} />;
    }

    return (
        <Card Titre={CardEcourrier.titleName} className={className}>
            {composant}
        </Card>
    );
};
CardEcourrier.displayName = 'CardEcourrier';
CardEcourrier.titleName = 'Mon courrier électronique';
CardEcourrier.requiredProps = [
    'Ecourrier', // Informations eCourrier
    'actions', // Redux
    'history', // React Router
];

function mapStateToProps({
    ProStore: {
        Pro: { Ecourrier },
    },
    SynStore: {
        Syn: { LREOk, CourrierSimple },
    },
}) {
    return { Ecourrier, LREOk, CourrierSimple };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default withRouter(connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(CardEcourrier)));



// WEBPACK FOOTER //
// ./src/components/MesInfos/CardEcourrier.js